/*  UAT SERVER CONFIGURATION */
// export const backendUrl = "https://dev-api.alder.in";
// export const serverFileUrl = "https://dev-erp.alder.in/download/invExcel/";
// export const imageBaseUrl = "https://dev-api.alder.in/images";
// export const alderLogoUrl = "https://dev-erp.alder.in/download/alder2.png";
/* PRODUCTION CONFIG */
export const backendUrl = "https://api.alder.in";
export const serverFileUrl = "https://erp.alder.in/download/invExcel/";
export const imageBaseUrl = "https://api.alder.in/images";
export const alderLogoUrl = "https://erp.alder.in/download/alder2.png";
/* TEST SERVER CONFIG */
// export const backendUrl = "http://localhost:5000";
// export const serverFileUrl = "http://3.134.68.207/alder-dev/alder-server/invExcel/";
// export const imageBaseUrl = "https://dev-api.alder.in/images";
// export const alderLogoUrl = "https://dev-erp.alder.in/download/alder2.png";


// export const firebaseConfig = {
//   apiKey: "AIzaSyAiGxPYOUrXinGDjSu4QjOi5X5Z9uVro5I",
//   authDomain: "fireapp-7cada.firebaseapp.com",
//   databaseURL: "https://fireapp-7cada.firebaseio.com",
//   projectId: "fireapp-7cada",
//   storageBucket: "fireapp-7cada.appspot.com",
//   messagingSenderId: "405101290869",
//   appId: "1:405101290869:web:ef1db981033039c46b9f3c",
// };
// export const firebaseConfig = {
//   apiKey: "AIzaSyCOIRLJL4nhGVurGmXZ2bBAAC0TSYdSjuc",
//   authDomain: "barcode-scanner-13827.firebaseapp.com",
//   databaseURL: "https://barcode-scanner-13827.firebaseio.com",
//   projectId: "barcode-scanner-13827",
//   storageBucket: "barcode-scanner-13827.appspot.com",
//   messagingSenderId: "458222039606",
//   appId: "1:458222039606:web:9ebd4431363a85eaeb9e97"
// };
export const firebaseConfig = {
  apiKey: "AIzaSyBOJGUPxfpIus-79JFjeiZp5vpKnhVQ2R0",
  authDomain: "alder-f253f.firebaseapp.com",
  projectId: "alder-f253f",
  storageBucket: "alder-f253f.appspot.com",
  messagingSenderId: "849853989191",
  appId: "1:849853989191:web:08e578f8d69eaa31db0c62"
};
